var TopicSelectorSerialiser = require('topics/topic-selector-serialiser');
var CIDSerialiser = require('conversation/conversation-id-serialiser');

var FetchRequest = require('services/fetch/fetch-request');

module.exports = {
    read : function(input) {
        var selector = TopicSelectorSerialiser.read(input);
        var cid = CIDSerialiser.read(input);

        return new FetchRequest(cid, selector);
    },
    write : function(output, request) {
        TopicSelectorSerialiser.write(output, request.selector);
        CIDSerialiser.write(output, request.cid);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/fetch/fetch-request-serialiser.js
// module id = 1062
// module chunks = 0